"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('setup.scripts.client', function () {
    namespace_1.default.utils.extend(this, new namespace_1.default.setup.scripts());
    this.getUrl = function (type, name) {
        return namespace_1.default.params.paths[type].script + '/' + type + '.' + name + '.js?cb=' + namespace_1.default.params.cachebreaker;
    };
});
